import { AgResourceLanguage } from '../types';
import { shop as EnUsShop } from '../en-us/shop';

export const shop: AgResourceLanguage['shop'] = {
  ...EnUsShop,
  title: 'Butik AG1',
  category: 'Kategori',
  allProducts: 'Alla Produkter',
  gifts: 'Gåvor',
  supplements: 'Kosttillskott',
  subscriptions: 'Abonnemang',
  accessories: 'Tillbehör',
  gear: 'Utrustning',
  button: {
    addToCart: 'Lägg till i Varukorgen',
    addToNextOrder: 'Lägg till i Nästa Beställning',
    subscribe: 'Prenumerera',
    addedToNextOrder: 'Tillagd i Nästa Beställning'
  },
  singleSubscription: 'Enkel Prenumeration',
  doubleSubscription: 'Dubbel Prenumeration',
  description30: '30 Portioner',
  description60: '60 Portioner, bästa värde',
  descriptionIndividual30: '30 Individuella enportionsförpackningar',
  scoopAvailabilityInfo:
    '*Tillgänglig att lägga till i varukorgen när minst en annan produkt är i varukorgen',
  scoopPrompt: 'Behöver du en skopa till din påse? Lägg till den nedan gratis.'
};
